import { render, staticRenderFns } from "./Shippingstatistics.vue?vue&type=template&id=5b590b93&scoped=true&"
import script from "./Shippingstatistics.vue?vue&type=script&lang=js&"
export * from "./Shippingstatistics.vue?vue&type=script&lang=js&"
import style0 from "./Shippingstatistics.vue?vue&type=style&index=0&id=5b590b93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b590b93",
  null
  
)

export default component.exports